<template>
    <div>

        <!-- Start Services Details Area -->
		<section class="services-details-area ptb-80 mt-5">
			<div class="container">
				<div class="section-title">
                <h2>Domain And Hosting</h2>
                <div class="bar"></div>
            </div>
				<div class="row align-items-center">
					<div class="col-lg-6 services-details">
						<div class="services-details-desc">
							<p>Software development is the process of putting visions, ideas, coding and experience in a finished product which can result in a polished business strategy. It is important to understand the fact that there are a lot of tech companies providing software development services but not all can make it into a productive model. That is where WB tech comes in handy. Our highly experienced engineers are here to give you the software you need for your business. </p>

							<h3>Enterprise development</h3>
							<p>Our team will make a custom software based on our research of your business which takes care of your business data integrity and will let you do barrier free collaborations. By implementing enterprise solutions we make sure that your software environment is completely flawless and secure.</p>
						</div>
					</div>

					<div class="col-lg-6 services-details-image">
						<img src="../../../../assets/img/services-details-image/1.png" class="wow fadeInUp" v-wow alt="image">
					</div>
				</div>

				<div class="separate"></div>

				<div class="row align-items-center">
					<div class="col-lg-6 services-details-image">
						<img src="../../../../assets/img/services-details-image/2.png" class="wow fadeInUp" v-wow alt="image">
					</div>

					<div class="col-lg-6 services-details">
						<div class="services-details-desc">
							<p>Took a galley of type and scrambled it to make a type specimen book. survived not only five centuries, but also the leap into electronic remaining. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer when an unknown.</p>

							<div class="services-details-accordion">
								<VueFaqAccordion 
									:items="myItems"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
        <!-- End Services Details Area -->
    </div>
</template>

<script>
import VueFaqAccordion from 'vue-faq-accordion';
export default {
	name: 'SoftwerDevelopment',
	components: {
        VueFaqAccordion
    },
    data() {
        return {
            text: `Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute.`,
            myItems: [
                {
                    title: 'Innovative Technology',
                    value: 'We leverage cutting-edge technology and methodologies to develop powerful sales automation software.'
                },
                {
                    title: 'Customer Partners',
                    value: 'We apply deep domain and hosting knowledge to support our clients’ technology and business goals.'
                },
                {
                    title: 'First-Rate Services',
                    value: 'We are committed to delivering best-in-class technology and customer service, building long lasting business partnerships.'
                }
            ]
        }
    }
}
</script>